import { useTranslator } from '@/hooks'
import { ActivityLogTypeEnum } from '@/@data'
import Link from '@/components/Link'
import { LiftActivityLog } from '@/components/log/LiftActivityLog'

export const EmployeeActivityLog = () => {
  const { __ } = useTranslator();

  return (
    <LiftActivityLog
      object_type={ActivityLogTypeEnum.User}
      breadcrumb={
        <Link color='inherit' href='/cms/users/employee'>
          {__('Employee Management')}
        </Link>
      }
    />
  )
}
